import React from 'react';
import { CurrencySelector } from '@shared/components/CurrencySelector';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { usePrintSupportedCurrencies } from '@apps/card/hooks/usePrintSupportedCurrencies';

/**
 * PrintCurrencySelector component is a wrapper around the CurrencySelector component for print.
 * @returns CurrencySelector component for print
 */
export const PrintCurrencySelector = () => {
  const [isCurrencySelectorEnabled] = useIsFeatureEnabled('printLocalCurrency');
  const printSupportedCurrencies = usePrintSupportedCurrencies();

  return (
    <CurrencySelector
      isEnabled={isCurrencySelectorEnabled}
      supportedCurrencies={printSupportedCurrencies}
      dropdownPositionStyle={{ right: 0 }}
    />
  );
};
